/**
 * Author: Srilal S. Siriwardhane
 * Email: SrilalS@99x.io
**/
/**
 * AbstractLLMInferenceEngine is the abstract class that defines the abstract methods that
 * should be implemented by the LLMInferenceEngines.
 */
export class AbstractLLMInferenceEngine {
}
//# sourceMappingURL=AbstractLLMInferenceEngine.js.map